export default __webpack_public_path__ + "static/media/Montserrat-Light.8749526d.woff";